<lib-card [cardIcon]="'purchase'" [title]="title()">
	<div [className]="paddleContainerClassName"></div>
</lib-card>
